module.exports = __webpack_public_path__ + "img/hamburger.e9d77e1a.svg";